import styled from 'styled-components';

import { setMobileView } from '../../../../../tools/mobileView';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 40px;
  height: 150px;
  width: 310px;
`;

export const ButtonRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 5px;
  width: 100%;
`;

export const UpdateLabel = styled.label`
  margin-bottom: 4px;
`;

export const UpdateInput = styled.input`
  padding: 6px;
  font-size: 14px;
`;

export const UpdateTextarea = styled.textarea`
  padding: 6px;
  font-size: 14px;
`;

export const DeleteButton = styled.button`
    margin: 20px 0;
    min-width: ${setMobileView() ? '105px' : '125px'};
    width: auto;
    height: 40px;
    letter-spacing: 0.5px;
    line-height: 40px;
    padding: 0 15px 0 15px;
    font-size: ${setMobileView() ? '10px' : '12px'};
    background-color: red;
    color: white;
    text-transform: uppercase;
    font-family: 'Open Sans Condensed';
    font-weight: bolder;
    border: 1px solid white;
    border-radius: 1px;
    cursor: pointer;
    display: flex;
    justify-content: center;

    &:hover {
    background-color: #fff;
    color: red;
    border: 1px solid red;
    }
`;